import { render } from "./AddComposition.vue?vue&type=template&id=038c5ed7&scoped=true&ts=true"
import script from "./AddComposition.vue?vue&type=script&lang=ts"
export * from "./AddComposition.vue?vue&type=script&lang=ts"

import "./AddComposition.vue?vue&type=style&index=0&id=038c5ed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c5ed7"]])

export default __exports__